<template>
  <v-container>
    <v-form @submit.prevent="submit">
      <v-text-field
        label="회사명"
        v-model="company.name"
      ></v-text-field>
      <v-text-field
        label="사업자번호"
        v-model="company.companyNo"
      ></v-text-field>
      <v-text-field
        label="업종"
        v-model="company.companyType"
      ></v-text-field>
      <v-text-field
        label="관리자"
        v-model="company.adminstrator"
      ></v-text-field>
      <v-text-field
        label="연락처"
        v-model="company.contact"
      ></v-text-field>
      <v-btn type="submit" color="success">등록</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { getCompany, updateCompany } from '@/api'

export default {
  async beforeRouteEnter (to, from, next) {
    try {
      const company = await getCompany()
      next(vm => {
        Object.assign(vm.$data.company, company)
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  data () {
    return {
      company: {
        name: '',
        companyNo: '',
        companyType: '',
        adminstrator: '',
        contact: ''
      }
    }
  },
  methods: {
    async submit () {
      if (this.loading) return
      this.loading = true
      try {
        updateCompany(this.company)
        alert('성공')
      } catch (err) {
        alert(err.message)
      }

      this.loading = false
    }
  }
}
</script>
